<script setup lang="ts">
import DashboardPanel from '@/modules/dashboard/components/DashboardPanel.vue';
import LoansHistoryTable from '@/modules/open-loans/components/LoansHistoryTable.vue';
import { provide } from 'vue';
import i18n from '@/localisation/i18n';

// for column state persistence
// @TODO: we should type provide/inject after we migrate all components to composition API
// (https://vuejs.org/guide/typescript/composition-api.html#typing-provide-inject)
provide('gridStateKey', 'LoansHistory');
</script>

<template>
  <DashboardPanel no-collapse :title="i18n.t('sidebar.items.loansHistory')">
    <LoansHistoryTable />
  </DashboardPanel>
</template>
